import { Link } from '@inertiajs/react';
import { HomeSectionLayout } from '../../../../../components/HomeSectionLayout';
import { FeaturedContentItem } from '../index';
import { BreadCrumbs } from '../../../../../components/BreadCrumbs';
import { MediaAttachmentCard } from '../../../../Admin/AttachmentGroups/MediaAttachmentCard';
import { SECTION_COLORS } from '../../../../../utils/colors';

interface AttachmentsGroupItem extends FeaturedContentItem {
  title: string;
  description?: string;
  attachments: Array<{
    id: number;
    title?: string;
    public_url: string;
    thumbnail_url?: string;
  }>;
}

export default function AttachmentsGroupSection({ item, index }: { item: FeaturedContentItem; index: number }) {
  const group = item as AttachmentsGroupItem;
  const colors = SECTION_COLORS[index % SECTION_COLORS.length];

  return (
    <HomeSectionLayout.Container style={{
      backgroundColor: colors.bg,
      color: colors.text
    }}>
      <div style={{
        width: '100%'
      }}>
        <HomeSectionLayout.HeaderDescription>
          <BreadCrumbs.Container>
            <BreadCrumbs.LinkItem href="/reference">
              Attachments
            </BreadCrumbs.LinkItem>
          </BreadCrumbs.Container>
        </HomeSectionLayout.HeaderDescription>
        <HomeSectionLayout.Header>{group.title}</HomeSectionLayout.Header>
      </div>
      {group.description && (
        <div style={{
          width: '100%'
        }}>
          {group.description}
        </div>
      )}
      <HomeSectionLayout.Content>
        <div style={{
          gap: '20px',
          width: '100%',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        }}>
          {group.attachments.map((attachment) => (
            <div>
              <MediaAttachmentCard
                key={`attachment-card-${attachment.id}`}
                attachment={attachment}
                href={`/media/${group.id}/attachments/${attachment.id}`}
              />
            </div>
          ))}
        </div>
      </HomeSectionLayout.Content>
    </HomeSectionLayout.Container>
  )
}
